<template>
<v-app ref="test3">
  <NavBarDesktop
    v-if="!$vuetify.breakpoint.smAndDown"
    :is_logged_in="is_logged_in"
    />
  <NavBarMobile
    v-else-if="is_mobile_navbar_visible"
    :is_logged_in="is_logged_in"
    />
  <v-dialog v-model="show_browser_dialog" persistent max-width="500">
    <v-card>
      <v-card-title class="headline">TAKT.ing browser support</v-card-title>
      <v-card-text>
        Hello, we noticed you are not using Google Chrome.<br>
        Unfortunately at this state we can only guarantee the website to work on Google Chrome.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="show_browser_dialog = false">Continue anyways.</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-content>

    <!-- USER FEEDBACK -->
    <v-alert
      dense
      type="warning"
      :color="user_feedback.msg?'':'red lighten-2'"
      icon="report_problem"
      close-icon="close"
      class="user-feedback-alert"
      v-model="user_feedback_alert"
      dismissible
    >
      {{ user_feedback.msg || 'An internal Error occured :( You did nothing wrong, but if you want, send us your screenshot to support@takting.com'}}
    </v-alert>

    <div class="bug-bg" v-if="getBugDialog.show">
      <v-card color="color-3" class="bug-dialog">
        <v-system-bar color="color-2">
          <v-spacer></v-spacer>
          <div @click="toggleBugDialog(false)">
            <TIcon name="close" color="white" />
          </div>
          <v-icon @click="toggleBugDialog(false)">mdi-close</v-icon>
        </v-system-bar>
        <v-card-text>
          <h1>An error occured <small>[{{getBugDialog.payload.error.status}} - {{getBugDialog.payload.error.statusText}}]</small></h1>
          <v-alert class="mt-3" type="error">
            {{getBugDialog.payload.error.msg}}
          </v-alert>
          <div class="ml-1 mr-1 mt-5 info-border-top">
            <v-icon color="#2196f3">bug_report</v-icon>
            Is this a bug? Help improve TAKT.ing and report it using our bug report system. Thanks!
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="sendBugReport(getBugDialog.payload)">Submit bug report</v-btn>
          <v-btn text @click="getBugDialog.show = false">Continue working</v-btn>
        </v-card-actions>
        <!-- <v-card-title class="headline">An error occured <small>{{getBugDialog.payload.error.status}} <small>{{getBugDialog.payload.error.statusText}}</small></small></v-card-title>
        <v-card-subtitle>
          Help improving TAKT.ing by submitting a bug report.<br>
          <br>
          <h4>{{getBugDialog.payload.error.status}} <small>{{getBugDialog.payload.error.statusText}}</small></h4>
          <h5>{{getBugDialog.payload.error.msg}}</h5>
        </v-card-subtitle>
        <v-card-actions>
          <v-btn text @click="sendBugReport(getBugDialog.payload)">Submit bug report</v-btn>
        </v-card-actions> -->
      </v-card>
    </div>
    <!-- style="height: 100%" -->
    <router-view
      :style="`${getUseOnSite && $route && $route.name && $route.name.includes('Wallet') ? '' : `height: calc(${content_height}px) !important;`}`"
      :class="`content ${hasNoAutoOverflow($route.name) ? '' : 'overflow-auto'}`"
      >
        <!-- NOTE: a better solution is welcomed -->
        <!-- TODO: fix height for wallet -->
        <!-- :style="`${getUseOnSite ? '' : 'height: calc(${content_height}px) !important'}`" -->
        <!-- :style="`height: calc(${content_height}px) !important`" -->
    </router-view>
  </v-content>
  <div style="z-index: 400">
    <LanguagePopUp
      v-if="showLanguagePopUp"
      style="position: absolute; z-index: 1000; left: 50vw; top: 50vh"
      :value="LanguageValue"
      @closeOverlay="showLanguagePopUp = false"
    />
  </div>
  <div style="z-index: 300">
    <Footer
    v-if="!$vuetify.breakpoint.smAndDown"
    />
    <BottomNavigationMobile
    v-else-if="is_mobile_footer_visible"
    />
  </div>
</v-app>
</template>

<script>
import LanguagePopUp from '@/components/WorkPackageWIP/LanguagePopUp.component.vue';
import NavBarDesktop from '@/views/AppLayout/NavBarDesktop.view.vue'
import NavBarMobile from '@/views/AppLayout/NavBarMobile.view.vue'
import BottomNavigationMobile from '@/views/AppLayout/BottomNavigationMobile.view.vue'
import store from '@/store/index'
import Footer from '@/components/AppLayout/Footer.component.vue'
import TIcon from '@/components/Taktify/TIcon.component.vue'
import {
  mapActions,
  mapGetters,
  mapState
} from 'vuex';

export default {
  name: 'App',
  components: {
    NavBarDesktop,
    NavBarMobile,
    BottomNavigationMobile,
    Footer,
    TIcon,
    LanguagePopUp,
  },
  created() {
    if (this.$vuetify.breakpoint.smAndDown) {
      document.body.style.setProperty('--project_taktplan_spatial_header_width', 45);
    }

    // let browser = navigator.sayswho= (function(){
    //     let ua= navigator.userAgent, tem,
    //     M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    //     if(/trident/i.test(M[1])){
    //         tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
    //         return 'IE '+(tem[1] || '');
    //     }
    //     if(M[1]=== 'Chrome'){
    //         tem= ua.match(/\b(OPR|Edge?)\/(\d+)/);
    //         if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera').replace('Edg ', 'Edge ');
    //     }
    //     M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    //     if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    //     return M.join(' ');
    // })();


    // if (!browser.startsWith('Chrome') && !browser.startsWith('Safari') && !browser.startsWith('Edg')) {
    //   this.show_browser_dialog = true;
    // }
    // if (this.is_logged_in) {
    //   // returns promise
    //   this.initUser();
    // }

    // mobile 100vh fix
    // initialize
    // document.body.style.setProperty('--vh', `${window.innerHeight/100}px`)
    // //addEventListener
    // window.addEventListener('resize', () => {
    //   document.body.style.setProperty('--vh', `${window.innerHeight/100}px`)
    // })
    window.addEventListener('resize', () => {
      this.innerHeight = window.innerHeight;
    })
    this.innerHeight = window.innerHeight;

    this.$i18n.locale = localStorage.getItem('TAKT_language') || 'en';

    let stored_theme = localStorage.getItem('TAKT_theme');
    if (this.is_logged_in && this.getUser.email.includes('@yit.fi')) {
      // YIT behaviour
      // use white theme as default
      if (stored_theme == null || stored_theme == 'false') {
        this.$vuetify.theme.dark = false;
      } else {
        this.$vuetify.theme.dark = true;
      }
    } else {
      // default behaviour (everyone except YIT)
      // use darf theme as default
      if (stored_theme == null || stored_theme == 'true') {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    }

    let workbench_sorting = localStorage.getItem('Workbench_Sorting');
    if(workbench_sorting == null)
      this.$store.state.View.workbench_sorting = 'Updated date (asc)';
    else
      this.$store.state.View.workbench_sorting = workbench_sorting;

    // DISPLAY SETTINGS AND ON_SITE
    let ds; // display setting
    let ds_val; // either true or false
    let display_settings = [
      { key: 'is_taktplan_grid_column', localStorage: 'Taktplan_Grid_Column', default: false },
      { key: 'is_taktplan_grid_row', localStorage: 'Taktplan_Grid_Row', default: false },
      { key: 'is_taktplan_takttime_highlight', localStorage: 'Takt_Time_Highlight', default: true },
      { key: 'is_taktplan_milestone_highlight', localStorage: 'Milestone_Highlight', default: false },
      { key: 'is_taktplan_train_seperator', localStorage: 'Train_Seperator', default: false },
      { key: 'is_taktplan_legend', localStorage: 'Taktplan_Legend', default: false },
      { key: 'is_taktplan_legend_left', localStorage: 'Taktplan_Legend_Left', default: false },
      { key: 'is_taktplan_legend_left_rotated', localStorage: 'Taktplan_Legend_Left_Rotated', default: false },
      { key: 'is_taktplan_legend_milestones', localStorage: 'Is_Taktplan_Legend_Milestones', default: false },
      { key: 'is_taktplan_show_only_filtered_workpackages', localStorage: 'Is_Taktplan_Show_onlyFiltered_Workpackage', default: false },
      { key: 'is_taktplan_timestamp', localStorage: 'Taktplan_Timestamp', default: true },
      { key: 'is_taktplan_taktarea_description', localStorage: 'Taktplan_Taktarea_Description', default: false },
      { key: 'on_site', localStorage: 'On_Site', default: true },
      { key: 'is_project_overview_show_terminated', localStorage: 'Project_Overview_Show_Terminated', default: false },
      { key: 'is_project_overview_show_company_only', localStorage: 'Project_Overview_Show_Company_Only', default: false },
      { key: 'show_taktplan_shadows', localStorage: 'Taktplan_Shadows', default: true},
      { key: 'use_intersection_observer', localStorage: 'Taktplan_Intersection_Observer', default: true},
      { key: 'show_taktplan', localStorage: 'Show_Taktplan', default: true},
      { key: 'show_snowflakes', localStorage: 'Taktplan_Show_Snowflakes', default: true} 
    ];

    for(let i = 0; i < display_settings.length; i++) {
      ds = display_settings[i];
      ds_val = localStorage.getItem(ds.localStorage);

      if ((ds_val == null && ds.default) || ds_val == 'true') {
        this.$store.state.View[ds.key] = true;
      } else {
        this.$store.state.View[ds.key] = false;
      }
    }
    // /DISPLAY SETTINGS

    // request language
    this.requestLanguage(this.getCurrentLanguage);
  },
  mounted() {
    this.$root.$on('openLanguagePopUp', (value) => {
      this.LanguageValue = value;
      this.showLanguagePopUp = true;
    })
  },
  beforeDestroy() {
  window.removeEventListener('resize');
  },
  data: () => ({
    show_browser_dialog: false,
    innerHeight: 0,
    showLanguagePopUp: false,
    LanguageValue: ''
  }),
  computed: {
    // mobile_height() {
    //   return window.innerHeight;
    // },
    content_height() {
      //minus nav bars
      // let height = this.mobile_height;
      let height = this.innerHeight;
      if (this.isMobile) {
        if (this.is_mobile_navbar_visible) {
          height = height - 48;
        }
        if (this.is_mobile_footer_visible) {
          height = height - 56;

        }
      } else {
        height = height - 48 - 30;
      }
      return height;
    },
    user_feedback_alert: {
      get () {
        return store.state.View.user_feedback.show;
      },
      set (v) {
        if (!v) { store.commit('View/dismiss_user_feedback') }
      }
    },
    ...mapState('View', [
      'user_feedback',
    ]),
    ...mapGetters('View', [
      'isMobile',
      'getUseOnSite',
    ]),
    ...mapGetters('BugReport', [
      'getBugDialog'
    ]),
    ...mapGetters('Auth', [
      'getUser'
    ]),
    ...mapGetters('Language', [
      'getCurrentLanguage'
    ]),
    is_logged_in() {
      return this.$store.getters['Auth/isLoggedIn'];
    },
    is_mobile_navbar_visible() {
      if (!this.is_logged_in) {
        return true;
      }
      else if (this.$route.matched[0] && this.$route.matched[0].name === 'Project') {
        if (this.$route.matched[3]) {
          return false;
        } else {
          return true;
        }
      }
      else {
        return false;
      }
        // !is_logged_in ||
        // $route.matched[0] &&
        // $route.matched[0].name === 'Project' &&
        // !$route.matched[3]
        // ||
        // ($route.matched[0] &&
        // $route.matched[0].name === 'Project' &&
        // $route.matched[3] &&
        // $route.matched[3].name !== 'ProjectWalletWorkPackageInfo')
    },
    is_mobile_footer_visible() {
      if (this.is_logged_in) {
        // if (this.$route.matched[3]) {
        if (this.$route.matched[0] && this.$route.matched[0].name === 'Project') {
          return false;
        } else {
          return true;
        }
      }
      else {
        return false;
      }
      // is_logged_in &&
      //   !$route.matched[3]||
      //   (is_logged_in &&
      //   $route.matched[3] &&
      //   $route.matched[3].name !== 'ProjectWalletWorkPackage')
    }
  },
  methods: {
    // ...mapActions('Auth', [
    //   'initUser'
    // ]),
    ...mapActions('BugReport', [
      'toggleBugDialog',
      'sendBugReport'
    ]),
    ...mapActions('Language', [
      'requestLanguage'
    ]),
    hasNoAutoOverflow(name){
      switch (name) {
        case 'ProjectWalletTakt':
        case 'ProjectOverView':
          return true;
        default:
          return false;
      }
    },
    getContentHeight() {
      return '100%'
      // if (this.$vuetify.breakpoint.smAndDown) {
      //   return `calc(${window.innerHeight}px - 48px - 56px) !important`
      // } else {
      //   return `calc(${window.innerHeight}px - 48px - 30px) !important`
      // }
    }
  }
};
</script>

<style lang="scss">
  @import "~typeface-roboto/index.css";

  :root {
    --taktplan_zoom: 1;
    /* --workpackage_width: calc(54px * var(--taktplan_zoom));
    --workpackage_height: calc(34px * var(--taktplan_zoom)); */
    --workpackage_width: 54px;
    --workpackage_height: 34px;
    --waggon_width: 58px;
    --header_name_width: 62px;
    --header_background_color: #212121;
    /* --header_border_color: #121212; */
    --header_border_color: black;
    --statistics_height: 0px;
    --waggon_offset_x: 0px;
    --waggon_offset_y: 0px;

    --project_taktplan_ta_header_width: 62;
    --project_taktplan_ta_header_width_min: 62;
    --project_taktplan_spatial_header_width: 148;
    --project_taktplan_spatial_header_width_min: 74;

    --project_structure_ta_header_width: 170px;

    --project_structure_spatial_structure_details_height: 200;
    --project_structure_taktarea_steps_height: 100;

    /* mobile 100vh fix */
    /* --vh: 100px; */
  }
  input, textarea {
    color: var(--primary);
  }
  .bug-dialog {
      position: fixed !important;
      top: 50vh;
      left: 50vw;
      z-index: 20;
      width: 50vw;
      margin-left: -25vw;
      margin-top: -25vh;
      height: 50vh;
  }
  .bug-bg {
    position: fixed !important;
    left: 0px;
    top: 0px;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0,0,0,0.75);
    z-index: 19;
  }
  .content {
    position: fixed;
    height: 100%;
    width: 100%;
    /* padding: 46px 0px 56px 0px !important; */
    /* height: calc(100vh - 48px - 4px - 2px - 30px) !important; */
    /* margin: 3px 4px 0px 4px; */
  }
  .border-white-hover:hover {
    border: 1px solid white !important;
  }
  .cursor-cell{
    cursor: cell;
  }
  .cursor-col-resize {
    cursor: col-resize;
  }
  .cursor-e-resize {
    cursor: e-resize;
  }
  .cursor-s-resize {
    cursor: s-resize;
  }
  .cursor-row-resize {
    cursor: row-resize;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .cursor-grab {
    cursor: grab;
  }
  .cursor-none {
    cursor: none;
  }
  .t-rounded {
    border-radius: 3px;
  }
  .t-shadow {
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    /* margin-bottom: 5px; */
  }
  .self-centered {
    transform: translate(-50%, -50%)
  }
  .transition-all {
    transition: all 50ms ease-in-out;
  }
  .overflow-auto {
    overflow: auto;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-visible {
    overflow: visible;
  }
  .pull-right {
    float: right;
  }
  .pull-left {
    float: left;
  }
  .user-select-none {
    user-select: none;
  }
  .clear {
    clear: both;
  }
  .display-flex {
    display: flex;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .info-border-top {
    border: 0px;
    color: snow;
    border-top: 5px solid #2196f3 !important;
    border-radius: 4px;
    font-size: 16px;
    padding: 16px;
  }
  .color-white-10 {
    color: var(--v-primary-base) !important;
    opacity: 1 !important;
  }
  .color-white-09 {
    color: var(--v-primary-base) !important;
    opacity: 0.9 !important;
  }
  .color-white-08{
    color: var(--v-primary-base) !important;
    opacity: .8 !important;
  }
  .color-white-07{
    color: var(--v-primary-base) !important;
    opacity: .7 !important;
  }
  .color-white-06{
    color: var(--v-primary-base) !important;
    opacity: .6 !important;
  }
  .color-white-05{
    color: var(--v-primary-base) !important;
    opacity: .5 !important;
  }
  .color-white-04{
    color: var(--v-primary-base) !important;
    opacity: .4 !important;
  }
  .color-white-03{
    color: var(--v-primary-base) !important;
    opacity: .3 !important;
  }
  .color-white-02{
    color: var(--v-primary-base) !important;
    opacity: .2 !important;
  }
  .color-white-01{
    color: var(--v-primary-base) !important;
    opacity: .1 !important;
  }
  .user-feedback-alert {
    position: fixed !important;
    z-index: 9999999;
    width: 20vw !important;
    right: 5vw;
    top: 5vh;
  }

  .v-application.theme--light {
    fill: #000;
  }

  .v-application.theme--dark{
    fill: #FFF;
  }

  .basic-flex-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width:100%;
  }

  .basic-flex-col {
    display: flex;
    flex-direction: column;
  }

@media only screen and (max-width: 768px) {
  .user-feedback-alert {
    position: fixed !important;
    z-index: 9999999;
    width: 80vw !important;
    right: 5vw;
    top: 5vh;
  }
}

</style>
